
import { useState } from 'react';

export default function AICourse() {
  const [showModal, setShowModal] = useState<string | null>(null);

  const openModal = (content: string) => {
    setShowModal(content);
  };

  const closeModal = () => {
    setShowModal(null);
  };

  const handleRegistration = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      const response = await fetch(
        'https://readdy.ai/api/form/d39g7nafkoblkdk5cqn0',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(formData as any).toString(),
        }
      );

      if (response.ok) {
        alert(
          'お申し込みありがとうございます！登録情報をメールでお送りします。'
        );
        (e.target as HTMLFormElement).reset();
        closeModal();
      }
    } catch (error) {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  };

  // ページの最上部にスクロール
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ヒーローセクション */}
      <section 
        className="relative py-20 bg-cover bg-center bg-top"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/41aef813531fb8c2fe5dd103013749f2.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-purple-900/70 to-indigo-900/80"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
          <h1 className="text-6xl font-bold mb-6">
            AIオンライン無料講座
            <span className="block text-5xl bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent mt-4">
              30分×10講座で完全習得
            </span>
          </h1>
          <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed mb-8">
            世代を超えて学び合う、日本初のAI教育プログラム。
            基礎から実践まで、あなたのペースで確実にスキルアップできます。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => openModal('registration')}
              className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-cyan-600 hover:to-blue-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-play-circle-line text-xl"></i>
              今すぐ無料で受講開始
            </button>
            
            <button 
              onClick={() => openModal('course-content')}
              className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all border border-white/30 whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-book-open-line text-xl"></i>
              講座内容を詳しく見る
            </button>
          </div>
        </div>
      </section>

      {/* 特徴セクション */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              なぜ今、AI学習が必要なのか？
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              データが示す現実と、あなたが取るべき行動
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-pink-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-alarm-warning-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">緊急警告</h3>
              <p className="text-gray-600 mb-4">
                日本企業の92%が「AIの必要性は感じるが導入方法が分からない」と回答
              </p>
              <div className="bg-red-50 p-4 rounded-2xl">
                <p className="text-red-700 font-semibold">
                  このままでは「AI植民地」になる危険性
                </p>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">世代格差</h3>
              <p className="text-gray-600 mb-4">
                60代以上のAI利用率は9.5%まで低下、家族間のコミュニケーション断絶が深刻化
              </p>
              <div className="bg-yellow-50 p-4 rounded-2xl">
                <p className="text-yellow-700 font-semibold">
                  世代を超えた学習が解決策
                </p>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">解決策</h3>
              <p className="text-gray-600 mb-4">
                世代間協働学習により、学習効率が単世代学習の2.3倍向上することが実証済み
              </p>
              <div className="bg-green-50 p-4 rounded-2xl">
                <p className="text-green-700 font-semibold">
                  今すぐ行動を起こしましょう
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 講座概要セクション */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              30分×10講座の学習プログラム
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              基礎から実践まで、段階的に学べる完全カリキュラム
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Module 0 */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-6 border border-purple-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  0
                </div>
                <div>
                  <h3 className="text-lg font-bold text-purple-800">AI心理診断</h3>
                  <p className="text-purple-600 text-sm">5分</p>
                </div>
              </div>
              <p className="text-purple-700 text-sm">
                AIとの向き合い方を見つける準備講座
              </p>
            </div>

            {/* Module 1 */}
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-6 border border-blue-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  1
                </div>
                <div>
                  <h3 className="text-lg font-bold text-blue-800">AIの基本概念</h3>
                  <p className="text-blue-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-blue-700 text-sm">
                AI・機械学習・深層学習の違いを理解
              </p>
            </div>

            {/* Module 2 */}
            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-6 border border-green-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-teal-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  2
                </div>
                <div>
                  <h3 className="text-lg font-bold text-green-800">ChatGPT活用</h3>
                  <p className="text-green-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-green-700 text-sm">
                プロンプト作成から高度な活用法まで
              </p>
            </div>

            {/* Module 3 */}
            <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-3xl p-6 border border-yellow-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  3
                </div>
                <div>
                  <h3 className="text-lg font-bold text-yellow-800">画像生成AI</h3>
                  <p className="text-yellow-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-yellow-700 text-sm">
                Midjourney・DALL-E・Stable Diffusion
              </p>
            </div>

            {/* Module 4 */}
            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-3xl p-6 border border-indigo-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  4
                </div>
                <div>
                  <h3 className="text-lg font-bold text-indigo-800">動画・音声AI</h3>
                  <p className="text-indigo-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-indigo-700 text-sm">
                RunwayML・ElevenLabs等の最新ツール体験
              </p>
            </div>

            {/* Module 5 */}
            <div className="bg-gradient-to-br from-pink-50 to-red-50 rounded-3xl p-6 border border-pink-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-red-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  5
                </div>
                <div>
                  <h3 className="text-lg font-bold text-pink-800">ビジネス活用</h3>
                  <p className="text-pink-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-pink-700 text-sm">
                業界別事例から学ぶ実践的活用法
              </p>
            </div>

            {/* Module 6 */}
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-6 border border-teal-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  6
                </div>
                <div>
                  <h3 className="text-lg font-bold text-teal-800">創造性融合</h3>
                  <p className="text-teal-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-teal-700 text-sm">
                人間の創造力とAIの協働可能性
              </p>
            </div>

            {/* Module 7 */}
            <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-3xl p-6 border border-violet-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  7
                </div>
                <div>
                  <h3 className="text-lg font-bold text-violet-800">AI倫理</h3>
                  <p className="text-violet-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-violet-700 text-sm">
                責任あるAI活用のためのガイドライン
              </p>
            </div>

            {/* Module 8 */}
            <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-3xl p-6 border border-emerald-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-green-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  8
                </div>
                <div>
                  <h3 className="text-lg font-bold text-emerald-800">未来技術</h3>
                  <p className="text-emerald-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-emerald-700 text-sm">
                AGI・量子AI・脳コンピュータ
              </p>
            </div>

            {/* Module 9 */}
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-3xl p-6 border border-amber-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-yellow-600 rounded-xl flex items-center justify-center text-white font-bold text-sm">
                  9
                </div>
                <div>
                  <h3 className="text-lg font-bold text-amber-800">AIと共生する働き方</h3>
                  <p className="text-amber-600 text-sm">30分</p>
                </div>
              </div>
              <p className="text-amber-700 text-sm">
                AI時代のキャリア戦略と終身学習
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <button 
              onClick={() => openModal('course-content')}
              className="bg-gradient-to-r from-blue-600 to-purple-700 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-blue-700 hover:to-purple-800 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3 mr-4"
            >
              <i className="ri-eye-line text-xl"></i>
              全講座の詳細を見る
            </button>
            
            <button 
              onClick={() => openModal('learning-flow')}
              className="bg-gradient-to-r from-green-600 to-teal-700 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-green-700 hover:to-teal-800 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-time-line text-xl"></i>
              学習の流れを詳しく見る
            </button>
          </div>
        </div>
      </section>

      {/* この講座で得られることセクション */}
      <section className="py-16 bg-gradient-to-br from-cyan-50 to-blue-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              この講座で得られること
            </h2>
            <p className="text-xl text-cyan-700 max-w-3xl mx-auto font-medium">
              30分間の投資で、AIとの関係性が根本的に変わります
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-cyan-200">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                AIの基礎と最新動向を短時間で理解
              </h3>
              <p className="text-gray-700 leading-relaxed text-center">
                複雑に見えるAI技術を、分かりやすく体系的に整理。最新トレンドも含めて効率的に学習できます。
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg border border-green-200">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-tools-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                仕事や生活にAIをどう活かすかのヒント
              </h3>
              <p className="text-gray-700 leading-relaxed text-center">
                抽象的な知識で終わらせず、具体的にあなたの日常で使える応用方法を発見できます。
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg border border-purple-200">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-brain-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                AIとの対話を通じた批判的思考と創造性の向上
              </h3>
              <p className="text-gray-700 leading-relaxed text-center">
                AIを単なるツールとして使うのではなく、思考パートナーとして活用する方法を身につけます。
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg border border-orange-200">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                学びを行動に移すための具体的な一歩
              </h3>
              <p className="text-gray-700 leading-relaxed text-center">
                講座の最後には必ず「明日からできること」を明確化。学習が確実に行動につながります。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 運営機関紹介セクション */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              運営機関の紹介
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              信頼できる専門機関と経験豊富な講師陣
            </p>
          </div>

          {/* 母体：インクリース */}
          <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center">
                <i className="ri-building-4-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">母体：インクリース</h3>
                <p className="text-gray-600">企業体</p>
              </div>
            </div>
            <p className="text-gray-700 mb-6">
              インクリースは、AIを文化的インフラとして社会に定着させることをミッションに掲げる企業体です。講座の企画・運営から技術開発、コミュニティ運営まで一貫して担い、堅牢な基盤を築いています。
            </p>
          </div>

          {/* 主幹：Ken */}
          <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl flex items-center justify-center">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">主幹：Ken</h3>
                <p className="text-gray-600">Visionary System Designer & Narrative Architect</p>
              </div>
            </div>
            <p className="text-gray-700 mb-6">
              AIと人間の感覚を共鳴させる文化的インフラを切り拓く実践的ビジョナリー。技術的厳密さと詩的感性を両立し、変革と共創をリードします。AI診断と物語的伴走の融合、システム設計、チームファシリテーションなど幅広い専門スキルを持ち、人間的温かみを重視したアプローチで信頼関係を築きます。
            </p>
            <button
              onClick={() => openModal('ken-profile')}
              className="bg-gradient-to-r from-green-500 to-teal-600 text-white px-6 py-3 rounded-2xl font-bold hover:from-green-600 hover:to-teal-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-2"
            >
              <i className="ri-eye-line"></i>
              詳しいプロフィールを見る
            </button>
          </div>

          {/* NEXT事業部 */}
          <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-2xl flex items-center justify-center">
                <i className="ri-compass-3-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">NEXT事業部</h3>
                <p className="text-gray-600">3つのプレットフォーム</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="border-l-4 border-cyan-500 pl-6">
                <h4 className="text-lg font-bold text-cyan-800 mb-2">Next Compass</h4>
                <p className="text-gray-700 mb-2">
                  「AIが地図を描き、人が伴走する」を掲げ、3分間の診断と作戦会議を通じて90分で未来航路を設計するプラットフォームです。
                </p>
                <a href="https://nextcompass.net/" target="_blank" rel="noopener noreferrer" className="text-cyan-600 hover:text-cyan-800 font-medium">
                  https://nextcompass.net/
                </a>
              </div>

              <div className="border-l-4 border-blue-500 pl-6">
                <h4 className="text-lg font-bold text-blue-800 mb-2">Next Engine Lab</h4>
                <p className="text-gray-700 mb-2">
                  「仕組みが回れば、未来は加速する」を標榜。個人事業や副業に特化した業務自動化パッケージを提案し、40時間分の業務を5時間に短縮する診断サービスを提供します。
                </p>
                <a href="https://nextenginelab.jp/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-medium">
                  https://nextenginelab.jp/
                </a>
              </div>

              <div className="border-l-4 border-purple-500 pl-6">
                <h4 className="text-lg font-bold text-purple-800 mb-2">Next Light House</h4>
                <p className="text-gray-700 mb-2">
                  「未来の海を照らす、人間らしさの光」をコンセプトに、効率化の波に飲まれず感性資本を守り育む場を創る灯台的プラットフォームです。
                </p>
                <a href="https://nextligthouse.com/" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-800 font-medium">
                  https://nextligthouse.com/
                </a>
              </div>
            </div>
          </div>

          {/* デルタプロジェクト */}
          <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center">
                <i className="ri-triangle-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">デルタプロジェクト</h3>
                <p className="text-gray-600">3つのサービス</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="border-l-4 border-purple-500 pl-6">
                <h4 className="text-lg font-bold text-purple-800 mb-2">SINRO 心路</h4>
                <p className="text-gray-700 mb-2">
                  個人の感覚をデータ化し、言語として未来を描くフレームワークを提供します。
                </p>
                <a href="https://shinro.life/" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-800 font-medium">
                  https://shinro.life/
                </a>
              </div>

              <div className="border-l-4 border-pink-500 pl-6">
                <h4 className="text-lg font-bold text-pink-800 mb-2">YUIRU 結路</h4>
                <p className="text-gray-700 mb-2">
                  感覚と行動をつなぎ、個人とコミュニティを結ぶプロセス設計プラットフォーム。
                </p>
                <span className="text-gray-500 font-medium">構築中</span>
              </div>

              <div className="border-l-4 border-red-500 pl-6">
                <h4 className="text-lg font-bold text-red-800 mb-2">デルタ</h4>
                <p className="text-gray-700 mb-2">
                  SHINRO→YUIRUを礎に、変革を加速する文化的インフラを統合的に構築するエンタープライズ・フレームワーク。
                </p>
                <span className="text-gray-500 font-medium">構築中</span>
              </div>
            </div>
          </div>

          {/* ApAuraグループ */}
          <div className="bg-white rounded-3xl p-8 shadow-lg mb-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center">
                <i className="ri-movie-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">ApAuraグループ</h3>
                <p className="text-gray-600">体験型プログラム</p>
              </div>
            </div>
            
            <div className="border-l-4 border-orange-500 pl-6">
              <h4 className="text-lg font-bold text-orange-800 mb-2">LifeWave</h4>
              <p className="text-gray-700 mb-2">
                AIが「予告編から形になる体験型プログラム」を通じて、個人の人生物語を伴走支援。60秒の自動スライドで感情を呼び起こし、予告編制作から発信までを一気通貫でサポートします。
              </p>
              <a href="https://lifewaveai.com/" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:text-orange-800 font-medium">
                https://lifewaveai.com/
              </a>
            </div>
          </div>

          {/* 組織連携による文化革新 */}
          <div className="bg-gradient-to-br from-gray-900 to-blue-900 rounded-3xl p-8 text-white">
            <div className="text-center mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-links-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">組織連携による文化革新</h3>
            </div>
            <p className="text-blue-100 leading-relaxed text-center">
              強固な岩盤としての組織基盤の上に、NEXT事業部・デルタプロジェクト・ApAuraグループが連携。
              デルタ構想は、AI育成学舎を超えた次なるステージとして存在し、持続的な文化革新を実現します。
            </p>
          </div>
        </div>
      </section>

      {/* 松下村塾の精神継承セクション */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              時代を動かした松下村塾の精神は、 
            </h2>
            <h3 className="text-4xl font-bold bg-gradient-to-r from-red-600 to-orange-600 bg-clip-text text-transparent mb-8">
              いま再びAI育成学舎へと受け継がれる
            </h3>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              外的脅威から生まれた"志"、身分を超えた"包摂性"、対話を重んじる"学び"、そして実践を志向する"実学"──
              <br />
              幕末の塾生たちが未来を切り拓いたように、私たちもまたAI時代の新たな志士を育む学び舎を目指します。
            </p>
          </div>

          <div className="mb-16">
            <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">4つの思想的類似点</h3>
            
            <div className="grid md:grid-cols-2 gap-8">
              {/* 1. 危機感から生まれる「志」の教育 */}
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl p-8 border border-red-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-600 rounded-2xl flex items-center justify-center text-4xl">
                    🔥
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-red-800">1. 危機感から生まれる「志」の教育</h4>
                  </div>
                </div>
                <p className="text-red-700 leading-relaxed">
                  松塾は、外的脅威（黒船来航）に対し「この国をどうするか」という志を灯す場でした。AI育成学舎も、AI時代という外的圧力に対し、個々が志を持ち変化を挑む意味を提供します。
                </p>
              </div>

              {/* 2. 身分や年齢を問わない「包摂性」 */}
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 border border-blue-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center text-4xl">
                    🤝
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-blue-800">2. 身分や年齢を問わない「包摂性」</h4>
                  </div>
                </div>
                <p className="text-blue-700 leading-relaxed">
                  松塾は、身分・階級・年齢の壁を越えて学びを提供し、AI育成学舎も同様に、世代・職種・スキルの壁を越えた学びの場を提供します。
                </p>
              </div>

              {/* 3. 一方通行ではない「対話」中心の学び */}
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-8 border border-purple-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center text-4xl">
                    💬
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-purple-800">3. 一方通行ではない「対話」中心の学び</h4>
                  </div>
                </div>
                <p className="text-purple-700 leading-relaxed">
                  吉田松陰は、一方的に教えるのではなく、対話と質問を通じて学生の主体性を育む教育を実践しました。AI育成学舎でも、AIとの対話・質問を通じたインタラクティブな学習体験を提供します。
                </p>
              </div>

              {/* 4. 実践と行動を志向する「実学」 */}
              <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8 border border-green-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl flex items-center justify-center text-4xl">
                    ⚡
                  </div>
                  <div>
                    <h4 className="text-2xl font-bold text-green-800">4. 実践と行動を志向する「実学」</h4>
                  </div>
                </div>
                <p className="text-green-700 leading-relaxed">
                  松塾は、理論だけでなく、実際に行動し、体験することで学びを深める実学的アプローチを採用。AI育成学舎も、理論と実践を組み合わせ、学習者が実際にAIを活用し、成果を出すことで学びを深化させます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AGIからASIへのロードマップ：シナリオ比較セクション */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              AGIからASIへのロードマップ：シナリオ比較
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              さまざまなロードマップや専門家の予測によると、AGI（汎用人工知能）初期兆候は2025年後半～2027年頃、正式なAGI実装は2028年頃、ASI（超知能）の萌芽期は2030年～2035年と想定されています。以下のフェーズ別に、技術進化と人類への明るい未来／暗い未来を描きます。
            </p>
          </div>

          {/* フェーズ別シナリオ比較テーブル */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">フェーズ別シナリオ比較</h3>
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-3xl shadow-lg overflow-hidden">
                <thead className="bg-gradient-to-r from-blue-600 to-purple-700 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left font-bold">フェーズ</th>
                    <th className="px-6 py-4 text-left font-bold">年次</th>
                    <th className="px-6 py-4 text-left font-bold">技術トレンド</th>
                    <th className="px-6 py-4 text-left font-bold">明るい未来</th>
                    <th className="px-6 py-4 text-left font-bold">暗い未来</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="px-6 py-4 font-semibold text-blue-700">フェーズⅠ</td>
                    <td className="px-6 py-4">2025後半～2027</td>
                    <td className="px-6 py-4">AGIプロトタイプの出現; NISQ量子機実用化</td>
                    <td className="px-6 py-4 text-green-700">・中小企業でAGI実験が進み、生産性が底上げされます。<br/>・研究現場で量子アルゴリズム検証が増加</td>
                    <td className="px-6 py-4 text-red-700">・デジタル格差が拡大し、AI非対応層の排除が深刻化。<br/>・プライバシー侵害事件が多発</td>
                  </tr>

                  <tr className="border-b border-gray-200 bg-gray-50">
                    <td className="px-6 py-4 font-semibold text-blue-700">フェーズⅡ</td>
                    <td className="px-6 py-4">2028～2030</td>
                    <td className="px-6 py-4">AGI商用化; 中規模エラー訂正量子機の試験運用</td>
                    <td className="px-6 py-4 text-green-700">・医療診断・教育で個別最適化。<br/>・量子×AIで新薬開発が劇的短縮</td>
                    <td className="px-6 py-4 text-red-700">・深層偽情報が横行し社会不信に。<br/>・量子暗号破りの懸念が顕在</td>
                  </tr>

                  <tr className="border-b border-gray-200">
                    <td className="px-6 py-4 font-semibold text-blue-700">フェーズⅢ</td>
                    <td className="px-6 py-4">2031～2035</td>
                    <td className="px-6 py-4">ASI萌芽期（超人的知能の初期実装）</td>
                    <td className="px-6 py-4 text-green-700">・気候変動やエネルギー問題への解決策が瞬時に生成。<br/>・新素材や基礎科学が飛躍的進展</td>
                    <td className="px-6 py-4 text-red-700">・制御不能リスクの高いAIモデルが出現。<br/>・自律兵器や監視技術の悪用が国際問題に</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* 各フェーズの詳細シナリオ */}
          <div className="space-y-8">
            <h3 className="text-2xl font-bold text-gray-900 text-center">各フェーズの詳細シナリオ</h3>
            
            {/* フェーズⅠ */}
            <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-6 mb-6">
              <h4 className="text-xl font-bold text-blue-800 mb-4">フェーズⅠ</h4>
              <p className="text-blue-700">
                AI技術の初期段階で、実験的なAIシステムが登場し、産業や研究に影響を与える。
              </p>
            </div>

            {/* フェーズⅡ */}
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-6 mb-6">
              <h4 className="text-xl font-bold text-purple-800 mb-4">フェーズⅡ</h4>
              <p className="text-purple-700">
                AIが商業的に利用されるようになり、変革が本格化。
              </p>
            </div>

            {/* フェーズⅢ */}
            <div className="bg-gradient-to-r from-green-50 to-teal-50 rounded-2xl p-6 mb-6">
              <h4 className="text-xl font-bold text-green-800 mb-4">フェーズⅢ</h4>
              <p className="text-green-700">
                ASIが出現し、人類の課題解決能力が飛躍的に向上する。<br/>一方で、制御不能なリスクも顕在化。
              </p>
            </div>
          </div>

          {/* 人類への問い */}
          <div className="mt-12 bg-gradient-to-r from-gray-900 to-blue-900 rounded-3xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-4">人類への問い</h3>
            <p className="text-xl mb-4">AGIからASIへの進化は止められません。</p>
            <p className="text-lg text-blue-200">どちらの未来を選ぶかは、倫理・ガバナンス・市民のリテラシー次第です。</p>
          </div>
        </div>
      </section>

      {/* AIの未来セクション */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              AIの未来と私たちの選択
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              技術の進歩は止まりません。重要なのは、その変化にどう向き合うかです。
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                明るい未来への道筋
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span>世代を超えて協働学習により、AI技術を人間らしく活用</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span>感覚と直感を重視した教育で、創造性を維持・発展</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span>倫理的なAI活用により、社会全体の幸福度向上</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span>継続的な学習により、変化に柔軟に対応できる人材育成</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-alert-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                避けるべきリスク
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span>AI技術格差による社会の分断と不平等の拡大</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span>人間の創造性や判断力の衰退・依存の深刻化</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span>プライバシー侵害や監視社会の到来</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-line text-red-500 mt-1"></i>
                  <span>世代間コミュニケーションの断絶と孤立の増加</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-12">
            <div className="bg-gradient-to-r from-blue-600 to-purple-700 rounded-3xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">今、行動を起こしましょう</h3>
              <p className="text-xl mb-6">
                未来は私たち一人ひとりの選択と行動によって決まります。
                AI時代を豊かに生きるための第一歩を、今日から始めませんか？
              </p>
              <button 
                onClick={() => openModal('registration')}
                className="bg-white text-blue-700 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
              >
                <i className="ri-rocket-line text-xl"></i>
                無料講座で学習を開始する
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 特別機能セクション */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              特別機能・サポート
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              学習をより効果的にするための充実したサポート体制
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* 受講生掲示板 */}
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 border border-blue-200 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-discuss-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-blue-800 mb-4">受講生掲示板</h3>
              <p className="text-blue-700 mb-6">
                世代を超えた学習コミュニティで質問・議論・情報共有。
                一人では解決できない疑問も、みんなで解決できます。
              </p>
              <button 
                onClick={() => openModal('forum-system')}
                className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-6 py-3 rounded-2xl font-bold hover:from-blue-600 hover:to-cyan-700 transition-all whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-eye-line"></i>
                詳細を見る
              </button>
            </div>

            {/* AI影響自己診断 */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-8 border border-purple-200 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-pulse-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-purple-800 mb-4">AI影響自己診断</h3>
              <p className="text-purple-700 mb-6">
                AIがあなたの生活・仕事・感情に与える影響を科学的に分析し、個人に最適化された学習プランを提案します。
              </p>
              <button 
                onClick={() => openModal('ai-diagnosis')}
                className="bg-gradient-to-r from-purple-500 to-pink-600 text-white px-6 py-3 rounded-2xl font-bold hover:from-purple-600 hover:to-pink-700 transition-all whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-play-line"></i>
                診断を開始
              </button>
            </div>

            {/* 個別サポート */}
            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8 border border-green-200 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-green-800 mb-4">個別サポート</h3>
              <p className="text-green-700 mb-6">
                学習でつまずいた時は、専門スタッフが個別にサポート。
                メール・チャット・ビデオ通話で丁寧に対応します。
              </p>
              <button 
                onClick={() => {
                  if (typeof window.REACT_APP_NAVIGATE === 'function') {
                    window.REACT_APP_NAVIGATE('/support');
                  }
                }}
                className="bg-gradient-to-r from-green-500 to-teal-600 text-white px-6 py-3 rounded-2xl font-bold hover:from-green-600 hover:to-teal-700 transition-all whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-mail-line"></i>
                サポート依頼
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA セクション */}
      <section className="py-16 bg-gradient-to-br from-blue-600 via-purple-700 to-indigo-800">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl font-bold mb-6">
            今すぐ始めて、AI時代を豊かに生きよう
          </h2>
          <p className="text-xl mb-8 text-blue-100">
            無料講座で基礎を学び、世代を超えたコミュニティで成長し続けましょう。
            あなたの未来は、今日の一歩から始まります。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => openModal('registration')}
              className="bg-white text-blue-700 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-graduation-cap-line text-xl"></i>
              無料講座に今すぐ登録
            </button>
            
            <button 
              onClick={() => openModal('ai-diagnosis')}
              className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all border border-white/30 whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-heart-pulse-line text-xl"></i>
              AI影響診断を受ける
            </button>
          </div>
        </div>
      </section>

      {/* フローティングボタン */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-r from-blue-600 to-purple-700 text-white rounded-full shadow-lg hover:from-blue-700 hover:to-purple-800 transition-all transform hover:scale-110 flex items-center justify-center z-40"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>

      {/* モーダル */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* ヘッダー */}
            <div className="sticky top-0 bg-white p-6 border-b border-gray-200 rounded-t-3xl">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-bold text-gray-900">
                  {showModal === 'registration' &&
                    'AIオンライン無料講座 - 受講登録'}
                  {showModal === 'course-content' &&
                    '30分×10講座の全体マップ'}
                  {showModal === 'ken-profile' && 'Ken プロフィール'}
                  {showModal === 'learning-flow' && '学習の流れ'}
                  {showModal === 'forum-system' && '受講生掲示板システム'}
                  {showModal === 'ai-diagnosis' && 'AI影響自己診断'}
                  {showModal === 'future-report' && 'AIの変遷ロードマップ（2025-2045年）'}
                </h3>
                <button
                  onClick={closeModal}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
            </div>

            {/* コンテンツ本体 */}
            <div className="p-6">
              {/* 受講登録 */}
              {showModal === 'registration' && (
                <>
                  <div className="mb-8">
                    <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-2xl mb-6">
                      <h4 className="text-xl font-bold text-blue-800 mb-4">
                        🎉 完全無料でご受講いただけます
                      </h4>
                      <div className="grid md:grid-cols-2 gap-4 text-sm">
                        <div className="flex items-center gap-2 text-blue-700">
                          <i className="ri-check-line text-green-500"></i>
                          <span>30分×10講座すべて無料</span>
                        </div>
                        <div className="flex items-center gap-2 text-blue-700">
                          <i className="ri-check-line text-green-500"></i>
                          <span>修了証明書発行</span>
                        </div>
                        <div className="flex items-center gap-2 text-blue-700">
                          <i className="ri-check-line text-green-500"></i>
                          <span>受講生掲示板利用権</span>
                        </div>
                        <div className="flex items-center gap-2 text-blue-700">
                          <i className="ri-check-line text-green-500"></i>
                          <span>個別サポート対応</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <form
                    onSubmit={handleRegistration}
                    className="space-y-6"
                    data-readdy-form
                    id="ai-course-registration"
                  >
                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          お名前 *
                        </label>
                        <input
                          type="text"
                          name="name"
                          required
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="山田太郎"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          年代 *
                        </label>
                        <select
                          name="age_group"
                          required
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm pr-8"
                        >
                          <option value="">選択してください</option>
                          <option value="10代">10代</option>
                          <option value="20代">20代</option>
                          <option value="30代">30代</option>
                          <option value="40代">40代</option>
                          <option value="50代">50代</option>
                          <option value="60代">60代</option>
                          <option value="70代以上">70代以上</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        メールアドレス *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="example@email.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        職業・業界
                      </label>
                      <input
                        type="text"
                        name="occupation"
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="例：会社員、自営業、学生、主婦など"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        AIに関する現在のレベル *
                      </label>
                      <div className="space-y-2">
                        <label className="flex items-center">
                          <input type="radio" name="ai_level" value="初心者" required className="mr-3" />
                          <span className="text-sm">初心者（AIについてほとんど知らない）</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_level" value="基礎レベル" required className="mr-3" />
                          <span className="text-sm">基礎レベル（ChatGPTを少し使ったことがある）</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_level" value="中級レベル" required className="mr-3" />
                          <span className="text-sm">中級レベル（ある程度使いこなせる）</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_level" value="上級レベル" required className="mr-3" />
                          <span className="text-sm">上級レベル（詳しく、他人に教えられる）</span>
                        </label>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        受講の目的・期待すること
                      </label>
                      <textarea
                        name="purpose"
                        rows={4}
                        maxLength={500}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm resize-none"
                        placeholder="例：仕事でAIを活用したい、家族とのコミュニケーションを改善したい、将来への不安を解消したいなど（500文字以内）"
                      />
                    </div>

                    <div className="flex items-start gap-3">
                      <input
                        type="checkbox"
                        name="newsletter"
                        id="newsletter"
                        className="mt-1"
                      />
                      <label htmlFor="newsletter" className="text-sm text-gray-600">
                        AI教育に関する最新情報やイベント案内を受け取る（任意）
                      </label>
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-gradient-to-r from-blue-600 to-purple-700 text-white py-4 rounded-xl text-lg font-bold hover:from-blue-700 hover:to-purple-800 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
                    >
                      無料講座に登録する
                    </button>

                    <p className="text-xs text-gray-500 text-center">
                      登録後、講座へのアクセス方法をメールでお送りします。
                      <br />
                      個人情報は適切に管理し、講座運営以外の目的では使用いたしません。
                    </p>
                  </form>
                </>
              )}

              {/* Kenのプロフィール詳細モーダル */}
              {showModal === 'ken-profile' && (
                <div className="space-y-6">
                  {/* 基本情報 */}
                  <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-6 border border-green-200">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-full flex items-center justify-center">
                        <i className="ri-user-star-line text-2xl text-white"></i>
                      </div>
                      <div>
                        <h4 className="text-2xl font-bold text-green-800">Ken</h4>
                        <p className="text-green-600 font-medium">Visionary System Designer & Narrative Architect</p>
                      </div>
                    </div>
                    <p className="text-green-700 leading-relaxed">
                      AIと人間の感覚を共鳴させる文化的インフラを切り拓く実践的ビジョナリー。技術的厳密さと詩的感性を両立し、変革と共創をリードします。
                    </p>
                  </div>

                  {/* 専門スキル */}
                  <div className="bg-white rounded-2xl p-6 border border-gray-200">
                    <h5 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                      <i className="ri-tools-line text-blue-600"></i>
                      専門スキル
                    </h5>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="space-y-3">
                        <div className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                          <div>
                            <h6 className="font-semibold text-gray-900">AI診断と物語的伴走の融合</h6>
                            <p className="text-gray-600 text-sm">個人の感覚をデータ化し、物語として未来を描くフレームワーク設計</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-purple-500 rounded-full mt-2 flex-shrink-0"></div>
                          <div>
                            <h6 className="font-semibold text-gray-900">システム設計</h6>
                            <p className="text-gray-600 text-sm">複雑な課題を統合的に解決するシステム・プロセス設計</p>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <div className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                          <div>
                            <h6 className="font-semibold text-gray-900">チームファシリテーション</h6>
                            <p className="text-gray-600 text-sm">多様な背景を持つメンバーの協働を促進する場づくり</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                          <div>
                            <h6 className="font-semibold text-gray-900">教育プログラム開発</h6>
                            <p className="text-gray-600 text-sm">感覚重視の学習体験設計と実践的カリキュラム構築</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 関心領域と哲学 */}
                  <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border border-purple-200">
                    <h5 className="text-xl font-bold text-purple-800 mb-4 flex items-center gap-3">
                      <i className="ri-brain-line text-purple-600"></i>
                      関心領域と哲学
                    </h5>
                    <div className="space-y-4">
                      <div>
                        <h6 className="font-semibold text-purple-800 mb-2">AIと人間の共創関係</h6>
                        <p className="text-purple-700 text-sm leading-relaxed">
                          AIを単なるツールではなく、人間の創造性を拡張するパートナーとして位置づけ、両者の特性を活かした協働のあり方を探求しています。
                        </p>
                      </div>
                      <div>
                        <h6 className="font-semibold text-purple-800 mb-2">感覚データの言語化</h6>
                        <p className="text-purple-700 text-sm leading-relaxed">
                          直感や感情といった曖昧な感覚を、構造化し、データとして活用できる形に変換する手法の開発に取り組んでいます。
                        </p>
                      </div>
                      <div>
                        <h6 className="font-semibold text-purple-800 mb-2">世代間学習の促進</h6>
                        <p className="text-purple-700 text-sm leading-relaxed">
                          異なる世代が持つ知恵と経験を相互に学び合える環境づくりを通じて、社会全体の学習能力向上を目指しています。
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* 目標とビジョン */}
                  <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-2xl p-6 border border-yellow-200">
                    <h5 className="text-xl font-bold text-orange-800 mb-4 flex items-center gap-3">
                      <i className="ri-rocket-line text-orange-600"></i>
                      目標とビジョン
                    </h5>
                    <div className="space-y-4">
                      <div className="bg-white rounded-xl p-4">
                        <h6 className="font-semibold text-orange-800 mb-2">短期目標（1-2年）</h6>
                        <p className="text-orange-700 text-sm leading-relaxed">
                          AI育成学舎を通じて1000人以上の多世代学習者コミュニティを構築し、実践的なAI活用スキルと人間的な感性の両方を育む教育モデルを確立する。
                        </p>
                      </div>
                      <div className="bg-white rounded-xl p-4">
                        <h6 className="font-semibold text-orange-800 mb-2">中長期ビジョン（3-10年）</h6>
                        <p className="text-orange-700 text-sm leading-relaxed">
                          AIと人間が真に協働する社会基盤を構築し、技術進歩が人間の幸福と創造性の向上に直結する文化的インフラを日本から世界に発信する。
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* アプローチと人物像 */}
                  <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-6 border border-cyan-200">
                    <h5 className="text-xl font-bold text-cyan-800 mb-4 flex items-center gap-3">
                      <i className="ri-heart-line text-cyan-600"></i>
                      アプローチと人物像
                    </h5>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <h6 className="font-semibold text-cyan-800 mb-2">コミュニケーションスタイル</h6>
                        <ul className="space-y-1 text-cyan-700 text-sm">
                          <li className="flex items-start gap-2">
                            <i className="ri-check-line text-green-500 mt-0.5 text-xs"></i>
                            <span>相手の立場に立った共感的対話</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <i className="ri-check-line text-green-500 mt-0.5 text-xs"></i>
                            <span>複雑な概念をわかりやすく伝える能力</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <i className="ri-check-line text-green-500 mt-0.5 text-xs"></i>
                            <span>建設的な議論を促進するファシリテーション</span>
                          </li>
                        </ul>
                      </div>
                      <div>
                        <h6 className="font-semibold text-cyan-800 mb-2">価値観と信念</h6>
                        <ul className="space-y-1 text-cyan-700 text-sm">
                          <li className="flex items-start gap-2">
                            <i className="ri-heart-line text-red-500 mt-0.5 text-xs"></i>
                            <span>人間的温かみを重視した関係構築</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <i className="ri-lightbulb-line text-yellow-500 mt-0.5 text-xs"></i>
                            <span>継続的学習と成長への強いコミット</span>
                          </li>
                          <li className="flex items-start gap-2">
                            <i className="ri-team-line text-blue-500 mt-0.5 text-xs"></i>
                            <span>多様性を活かした協働の推進</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* 連絡先・関連リンク */}
                  <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200">
                    <h5 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-3">
                      <i className="ri-links-line text-gray-600"></i>
                      関連プロジェクト
                    </h5>
                    <div className="grid md:grid-cols-2 gap-4 text-sm">
                      <div>
                        <h6 className="font-semibold text-gray-800 mb-2">主導プロジェクト</h6>
                        <ul className="space-y-1 text-gray-600">
                          <li>• AI育成学舎（現プロジェクト）</li>
                          <li>• Next Compass - 未来航路設計</li>
                          <li>• SINRO 心路</li>
                          <li>• LifeWave - 人生物語伴走</li>
                        </ul>
                      </div>
                      <div>
                        <h6 className="font-semibold text-gray-800 mb-2">協働組織</h6>
                        <ul className="space-y-1 text-gray-600">
                          <li>• インクリース（母体企業）</li>
                          <li>• NEXT事業部</li>
                          <li>• デルタプロジェクト</li>
                          <li>• ApAuraグループ</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 講座内容詳細モーダル */}
              {showModal === 'course-content' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-2xl mb-6">
                    <h4 className="text-xl font-bold text-blue-800 mb-4">
                      30分×10講座の全体マップ
                    </h4>
                    <p className="text-blue-700">
                      各講座は独立しているため、興味のある部分から受講することも可能です。
                    </p>
                  </div>

                  <div className="space-y-4">
                    {/* Module 0 */}
                    <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border border-purple-200">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center text-white font-bold">
                          0
                        </div>
                        <div>
                          <h5 className="text-lg font-bold text-purple-800">AI心理診断</h5>
                          <p className="text-purple-600 text-sm">5分</p>
                        </div>
                      </div>
                      <p className="text-purple-700 mb-3">
                        AIとの向き合い方を見つける準備講座
                      </p>
                      <div className="bg-white rounded-xl p-4">
                        <h6 className="font-semibold text-purple-800 mb-2">学習内容</h6>
                        <ul className="text-sm text-purple-700 space-y-1">
                          <li>• あなたのAI適性診断</li>
                          <li>• 学習スタイルの特定</li>
                          <li>• 個別学習プランの提案</li>
                        </ul>
                      </div>
                    </div>

                    {/* Module 1 */}
                    <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 border border-blue-200">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-xl flex items-center justify-center text-white font-bold">
                          1
                        </div>
                        <div>
                          <h5 className="text-lg font-bold text-blue-800">AIの基本概念</h5>
                          <p className="text-blue-600 text-sm">30分</p>
                        </div>
                      </div>
                      <p className="text-blue-700 mb-3">
                        AI・機械学習・深層学習の違いを理解
                      </p>
                      <div className="bg-white rounded-xl p-4">
                        <h6 className="font-semibold text-blue-800 mb-2">学習内容</h6>
                        <ul className="text-sm text-blue-700 space-y-1">
                          <li>• AIの歴史と発展</li>
                          <li>• 機械学習の基本原理</li>
                          <li>• 深層学習とニューラルネットワーク</li>
                          <li>• 実社会でのAI活用事例</li>
                        </ul>
                      </div>
                    </div>

                    {/* Module 2 */}
                    <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-6 border border-green-200">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-600 rounded-xl flex items-center justify-center text-white font-bold">
                          2
                        </div>
                        <div>
                          <h5 className="text-lg font-bold text-green-800">ChatGPT活用</h5>
                          <p className="text-green-600 text-sm">30分</p>
                        </div>
                      </div>
                      <p className="text-green-700 mb-3">
                        プロンプト作成から高度な活用法まで
                      </p>
                      <div className="bg-white rounded-xl p-4">
                        <h6 className="font-semibold text-green-800 mb-2">学習内容</h6>
                        <ul className="text-sm text-green-700 space-y-1">
                          <li>• 効果的なプロンプトの書き方</li>
                          <li>• 役割設定とコンテキスト指定</li>
                          <li>• 業務効率化の実践例</li>
                          <li>• 創作活動での活用方法</li>
                        </ul>
                      </div>
                    </div>

                    {/* 残りのモジュールも同様に詳細化 */}
                    <div className="text-center mt-6">
                      <p className="text-gray-600 text-sm">
                        Module 3〜9の詳細は受講登録後にご確認いただけます
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* 学習の流れモーダル */}
              {showModal === 'learning-flow' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-green-50 to-teal-50 p-6 rounded-2xl mb-6">
                    <h4 className="text-xl font-bold text-green-800 mb-4">
                      学習の流れ
                    </h4>
                    <p className="text-green-700">
                      あなたのペースで、確実にスキルアップできる学習システムです。
                    </p>
                  </div>

                  <div className="space-y-6">
                    {/* ステップ1 */}
                    <div className="flex gap-6">
                      <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                        1
                      </div>
                      <div className="flex-1">
                        <h5 className="text-lg font-bold text-gray-900 mb-2">受講登録</h5>
                        <p className="text-gray-700 mb-3">
                          簡単な情報入力で、すぐに学習を開始できます。
                        </p>
                        <div className="bg-blue-50 rounded-xl p-4">
                          <ul className="text-sm text-blue-700 space-y-1">
                            <li>• 基本情報の入力（3分程度）</li>
                            <li>• AI経験レベルの選択</li>
                            <li>• 学習目標の設定</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* ステップ2 */}
                    <div className="flex gap-6">
                      <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                        2
                      </div>
                      <div className="flex-1">
                        <h5 className="text-lg font-bold text-gray-900 mb-2">AI心理診断</h5>
                        <p className="text-gray-700 mb-3">
                          あなたに最適な学習方法を見つけます。
                        </p>
                        <div className="bg-green-50 rounded-xl p-4">
                          <ul className="text-sm text-green-700 space-y-1">
                            <li>• 5分間の簡単診断</li>
                            <li>• 個別学習プランの作成</li>
                            <li>• 推奨学習順序の提示</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* ステップ3 */}
                    <div className="flex gap-6">
                      <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                        3
                      </div>
                      <div className="flex-1">
                        <h5 className="text-lg font-bold text-gray-900 mb-2">段階的学習</h5>
                        <p className="text-gray-700 mb-3">
                          30分×10講座を自分のペースで進めます。
                        </p>
                        <div className="bg-orange-50 rounded-xl p-4">
                          <ul className="text-sm text-orange-700 space-y-1">
                            <li>• いつでも・どこでも受講可能</li>
                            <li>• 理解度チェック機能</li>
                            <li>• 実践課題で定着確認</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* ステップ4 */}
                    <div className="flex gap-6">
                      <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                        4
                      </div>
                      <div className="flex-1">
                        <h5 className="text-lg font-bold text-gray-900 mb-2">コミュニティ参加</h5>
                        <p className="text-gray-700 mb-3">
                          受講生掲示板で質問・議論・情報共有。
                        </p>
                        <div className="bg-purple-50 rounded-xl p-4">
                          <ul className="text-sm text-purple-700 space-y-1">
                            <li>• 世代を超えた学習コミュニティ</li>
                            <li>• 質問・回答の相互サポート</li>
                            <li>• 実践事例の共有</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* ステップ5 */}
                    <div className="flex gap-6">
                      <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                        5
                      </div>
                      <div className="flex-1">
                        <h5 className="text-lg font-bold text-gray-900 mb-2">修了・継続学習</h5>
                        <p className="text-gray-700 mb-3">
                          修了証明書の発行と継続的な学習サポート。
                        </p>
                        <div className="bg-yellow-50 rounded-xl p-4">
                          <ul className="text-sm text-yellow-700 space-y-1">
                            <li>• 修了証明書の発行</li>
                            <li>• 上級講座のご案内</li>
                            <li>• 継続的なコミュニティ参加</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* AI影響自己診断モーダル */}
              {showModal === 'ai-diagnosis' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-2xl mb-6">
                    <h4 className="text-xl font-bold text-purple-800 mb-4">
                      AI影響自己診断
                    </h4>
                    <p className="text-purple-700">
                      AIがあなたの生活・仕事・感情に与える影響を科学的に分析し、個人に最適化された学習プランを提案します。
                    </p>
                  </div>

                  <form className="space-y-6">
                    {/* 質問1: AI利用頻度 */}
                    <div className="bg-white rounded-2xl p-6 border border-purple-200">
                      <h5 className="text-lg font-bold text-gray-900 mb-4">1. 現在のAI利用頻度はどの程度ですか？</h5>
                      <div className="space-y-3">
                        <label className="flex items-center">
                          <input type="radio" name="ai_frequency" value="daily" className="mr-3" />
                          <span>毎日使用している（ChatGPT、画像生成AIなど）</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_frequency" value="weekly" className="mr-3" />
                          <span>週に数回使用している</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_frequency" value="monthly" className="mr-3" />
                          <span>月に数回程度</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_frequency" value="rarely" className="mr-3" />
                          <span>ほとんど使用していない</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_frequency" value="never" className="mr-3" />
                          <span>全く使用していない</span>
                        </label>
                      </div>
                    </div>

                    {/* 質問2: AI不安度 */}
                    <div className="bg-white rounded-2xl p-6 border border-purple-200">
                      <h5 className="text-lg font-bold text-gray-900 mb-4">2. AIの発展に対してどのような感情を抱いていますか？</h5>
                      <div className="space-y-3">
                        <label className="flex items-center">
                          <input type="radio" name="ai_anxiety" value="excited" className="mr-3" />
                          <span>とても期待している・ワクワクする</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_anxiety" value="positive" className="mr-3" />
                          <span>概ね前向きに捉えている</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_anxiety" value="neutral" className="mr-3" />
                          <span>特に感情はない・どちらでもない</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_anxiety" value="concerned" className="mr-3" />
                          <span>少し不安を感じる</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="ai_anxiety" value="anxious" className="mr-3" />
                          <span>とても不安・恐怖を感じる</span>
                        </label>
                      </div>
                    </div>

                    {/* 質問3: 学習スタイル */}
                    <div className="bg-white rounded-2xl p-6 border border-purple-200">
                      <h5 className="text-lg font-bold text-gray-900 mb-4">3. あなたの学習スタイルに最も近いものはどれですか？</h5>
                      <div className="space-y-3">
                        <label className="flex items-center">
                          <input type="radio" name="learning_style" value="hands_on" className="mr-3" />
                          <span>実際に触って試しながら学ぶのが好き</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_style" value="theory_first" className="mr-3" />
                          <span>まず理論を理解してから実践したい</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_style" value="visual" className="mr-3" />
                          <span>図や動画で視覚的に学ぶのが得意</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_style" value="discussion" className="mr-3" />
                          <span>人と議論しながら学ぶのが好き</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_style" value="self_paced" className="mr-3" />
                          <span>自分のペースでじっくり学びたい</span>
                        </label>
                      </div>
                    </div>

                    {/* 質問4: 目標 */}
                    <div className="bg-white rounded-2xl p-6 border border-purple-200">
                      <h5 className="text-lg font-bold text-gray-900 mb-4">4. AIを学ぶ主な目的は何ですか？</h5>
                      <div className="space-y-3">
                        <label className="flex items-center">
                          <input type="radio" name="learning_goal" value="work" className="mr-3" />
                          <span>仕事の効率化・キャリアアップ</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_goal" value="creativity" className="mr-3" />
                          <span>創作活動・趣味での活用</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_goal" value="daily_life" className="mr-3" />
                          <span>日常生活の改善・便利さ向上</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_goal" value="curiosity" className="mr-3" />
                          <span>純粋な知的好奇心・教養として</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="learning_goal" value="future" className="mr-3" />
                          <span>将来への不安解消・準備</span>
                        </label>
                      </div>
                    </div>

                    {/* 質問5: 時間 */}
                    <div className="bg-white rounded-2xl p-6 border border-purple-200">
                      <h5 className="text-lg font-bold text-gray-900 mb-4">5. 学習に使える時間はどの程度ですか？</h5>
                      <div className="space-y-3">
                        <label className="flex items-center">
                          <input type="radio" name="available_time" value="intensive" className="mr-3" />
                          <span>1日1時間以上確保できる</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="available_time" value="moderate" className="mr-3" />
                          <span>1日30分程度</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="available_time" value="light" className="mr-3" />
                          <span>1日15分程度</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="available_time" value="weekend" className="mr-3" />
                          <span>週末にまとめて学習したい</span>
                        </label>
                        <label className="flex items-center">
                          <input type="radio" name="available_time" value="flexible" className="mr-3" />
                          <span>不定期・空いた時間に</span>
                        </label>
                      </div>
                    </div>

                    {/* 診断結果ボタン */}
                    <div className="text-center">
                      <button 
                        type="button"
                        onClick={() => {
                          const form = document.querySelector('form');
                          const formData = new FormData(form as HTMLFormElement);
                          const frequency = formData.get('ai_frequency');
                          const anxiety = formData.get('ai_anxiety');
                          const style = formData.get('learning_style');
                          const goal = formData.get('learning_goal');
                          const time = formData.get('available_time');

                          if (!frequency || !anxiety || !style || !goal || !time) {
                            alert('すべての質問にお答えください。');
                            return;
                          }

                          let result = "【あなたのAI学習プロファイル】\n\n";
                          
                          if (frequency === 'daily' || frequency === 'weekly') {
                            result += "🟢 AI活用レベル: 中級者\n";
                            result += "すでにAIを活用されているあなたには、より高度な活用法や新しいツールの習得がおすすめです。\n\n";
                          } else if (frequency === 'monthly') {
                            result += "🟡 AI活用レベル: 初級者\n";
                            result += "基本的な使い方から始めて、徐々に活用範囲を広げていきましょう。\n\n";
                          } else {
                            result += "🔴 AI活用レベル: 入門者\n";
                            result += "まずはAIの基本概念から学び、簡単なツールから始めることをおすすめします。\n\n";
                          }

                          result += "【推奨学習アプローチ】\n";
                          if (style === 'hands_on') {
                            result += "実践重視型: まずツールを触ってみて、使いながら学ぶスタイルが最適です。\n";
                          } else if (style === 'theory_first') {
                            result += "理論先行型: AIの仕組みを理解してから実践に移るアプローチが効果的です。\n";
                          } else if (style === 'visual') {
                            result += "視覚学習型: 図解や動画を活用した学習が最も効率的です。\n";
                          } else if (style === 'discussion') {
                            result += "対話学習型: 受講生掲示板での議論や質問を積極的に活用しましょう。\n";
                          } else {
                            result += "自習型: 自分のペースで進められるオンライン講座が最適です。\n";
                          }

                          result += "\n【推奨学習計画】\n";
                          if (time === 'intensive') {
                            result += "集中学習プラン: 1週間で全講座完了を目指しましょう。\n";
                          } else if (time === 'moderate') {
                            result += "標準学習プラン: 2-3週間で全講座完了を目指しましょう。\n";
                          } else if (time === 'light') {
                            result += "ゆっくり学習プラン: 1ヶ月程度で全講座完了を目指しましょう。\n";
                          } else if (time === 'weekend') {
                            result += "週末集中プラン: 毎週末に2-3講座ずつ進めましょう。\n";
                          } else {
                            result += "フレキシブルプラン: 空いた時間に少しずつ進めましょう。\n";
                          }

                          if (anxiety === 'anxious' || anxiety === 'concerned') {
                            result += "\n【不安解消のために】\n";
                            result += "AIに対する不安をお持ちのようですね。まずは基礎講座で正しい知識を身につけ、受講生コミュニティで同じような不安を持つ方々と交流することをおすすめします。\n";
                          }

                          result += "\n診断結果に基づいて、最適な学習プランで進めていきましょう！";
                          
                          alert(result);
                        }}
                        className="bg-gradient-to-r from-purple-500 to-pink-600 text-white px-8 py-4 rounded-2xl text-lg font-bold hover:from-purple-600 hover:to-pink-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
                      >
                        <i className="ri-brain-line text-xl"></i>
                        診断結果を見る
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {/* 受講生掲示板システムモーダル */}
              {showModal === 'forum-system' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-blue-50 to-cyan-50 p-6 rounded-2xl mb-6">
                    <h4 className="text-xl font-bold text-blue-800 mb-4">
                      受講生掲示板システム
                    </h4>
                    <p className="text-blue-700">
                      世代を超えた学習コミュニティで質問・議論・情報共有ができます。
                    </p>
                  </div>

                  <div className="space-y-6">
                    {/* 機能紹介 */}
                    <div className="bg-white rounded-2xl p-6 border border-blue-200">
                      <h5 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                        <i className="ri-discuss-line text-blue-600"></i>
                        主な機能
                      </h5>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="space-y-3">
                          <div className="flex items-start gap-3">
                            <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                            <div>
                              <h6 className="font-semibold text-gray-900">質問・回答システム</h6>
                              <p className="text-gray-600 text-sm">学習中の疑問を気軽に質問し、他の受講生や講師から回答を得られます</p>
                            </div>
                          </div>
                          <div className="flex items-start gap-3">
                            <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                            <div>
                              <h6 className="font-semibold text-gray-900">学習進捗共有</h6>
                              <p className="text-gray-600 text-sm">自分の学習状況や成果を共有し、モチベーションを維持できます</p>
                            </div>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="flex items-start gap-3">
                            <div className="w-2 h-2 bg-purple-500 rounded-full mt-2 flex-shrink-0"></div>
                            <div>
                              <h6 className="font-semibold text-gray-900">世代間交流</h6>
                              <p className="text-gray-600 text-sm">異なる世代の受講生同士で経験や知識を共有し合えます</p>
                            </div>
                          </div>
                          <div className="flex items-start gap-3">
                            <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                            <div>
                              <h6 className="font-semibold text-gray-900">実践事例紹介</h6>
                              <p className="text-gray-600 text-sm">AIを実際に活用した成功事例や失敗談を共有できます</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 利用方法 */}
                    <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl p-6 border border-cyan-200">
                      <h5 className="text-xl font-bold text-cyan-800 mb-4 flex items-center gap-3">
                        <i className="ri-guide-line text-cyan-600"></i>
                        利用方法
                      </h5>
                      <div className="space-y-4">
                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                            1
                          </div>
                          <div>
                            <h6 className="font-semibold text-cyan-800">講座受講登録</h6>
                            <p className="text-cyan-700 text-sm">まず無料講座に登録すると、掲示板へのアクセス権が付与されます</p>
                          </div>
                        </div>
                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                            2
                          </div>
                          <div>
                            <h6 className="font-semibold text-cyan-800">プロフィール設定</h6>
                            <p className="text-cyan-700 text-sm">年代・職業・学習目標などを設定し、適切なマッチングを行います</p>
                          </div>
                        </div>
                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                            3
                          </div>
                          <div>
                            <h6 className="font-semibold text-cyan-800">積極的な参加</h6>
                            <p className="text-cyan-700 text-sm">質問投稿、回答、いいね、コメントなどで活発に交流しましょう</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* コミュニティルール */}
                    <div className="bg-yellow-50 rounded-2xl p-6 border border-yellow-200">
                      <h5 className="text-xl font-bold text-yellow-800 mb-4 flex items-center gap-3">
                        <i className="ri-shield-check-line text-yellow-600"></i>
                        コミュニティルール
                      </h5>
                      <ul className="space-y-2 text-yellow-700 text-sm">
                        <li className="flex items-start gap-2">
                          <i className="ri-check-line text-green-500 mt-0.5 text-xs"></i>
                          <span>相手を尊重し、建設的な議論を心がけましょう</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-check-line text-green-500 mt-0.5 text-xs"></i>
                          <span>世代や経験の違いを理解し、学び合いの姿勢を大切にしましょう</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-check-line text-green-500 mt-0.5 text-xs"></i>
                          <span>個人情報の共有は避け、プライバシーを守りましょう</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-check-line text-green-500 mt-0.5 text-xs"></i>
                          <span>商業的な宣伝や勧誘は禁止です</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {/* 未来予測レポートモーダル */}
              {showModal === 'future-report' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-2xl mb-6">
                    <h4 className="text-xl font-bold text-indigo-800 mb-4">
                      AIの変遷ロードマップ（2025-2045年）
                    </h4>
                    <p className="text-indigo-700">
                      AI育成学舎独自分析による詳細な未来予測レポート
                    </p>
                  </div>

                  <div className="space-y-8">
                    {/* フェーズ1：統合の時代 */}
                    <div className="bg-white rounded-2xl p-6 border border-blue-200">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-xl flex items-center justify-center text-white font-bold">
                          1
                        </div>
                        <div>
                          <h5 className="text-xl font-bold text-blue-800">フェーズ1：統合の時代（2025-2030年）</h5>
                        </div>
                      </div>
                      
                      <div className="space-y-4">
                        <div>
                          <h6 className="font-semibold text-blue-800 mb-2">技術的特徴：</h6>
                          <ul className="text-sm text-blue-700 space-y-1 ml-4">
                            <li>• GPT-4/5レベルのAIが社会の基盤インフラに</li>
                            <li>• マルチモーダルAI（音声、画像、動画の統合理解）の実用化</li>
                            <li>• 特定業務での人間超え（法務、医療診断、プログラミング）</li>
                          </ul>
                        </div>
                        
                        <div>
                          <h6 className="font-semibold text-blue-800 mb-2">社会への影響：</h6>
                          <ul className="text-sm text-blue-700 space-y-1 ml-4">
                            <li>• ホワイトカラー中間層の雇用危機（弁護士補助、会計士、翻訳者など）</li>
                            <li>• 「AIネイティブ企業」の急成長と既存企業の淘汰</li>
                            <li>• 教育システムの混乱（従来の知識詰め込み型の無意味化）</li>
                          </ul>
                        </div>

                        <div className="bg-red-50 rounded-xl p-4">
                          <h6 className="font-semibold text-red-800 mb-2">リスクの顕在化：</h6>
                          <ul className="text-sm text-red-700 space-y-1 ml-4">
                            <li>• <strong>格差の第一波</strong>：AIツールを使いこなせる層と使えない層の二極化</li>
                            <li>• <strong>ディープフェイクの政治利用</strong>：選挙介入、世論操作の常態化</li>
                            <li>• <strong>プライバシーの終焉</strong>：行動予測の精度向上で「隠れる自由」が消失</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* フェーズ2：分断の時代 */}
                    <div className="bg-white rounded-2xl p-6 border border-orange-200">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-xl flex items-center justify-center text-white font-bold">
                          2
                        </div>
                        <div>
                          <h5 className="text-xl font-bold text-orange-800">フェーズ2：分断の時代（2030-2037年）</h5>
                        </div>
                      </div>
                      
                      <div className="space-y-4">
                        <div>
                          <h6 className="font-semibold text-orange-800 mb-2">技術的特徴：</h6>
                          <ul className="text-sm text-orange-700 space-y-1 ml-4">
                            <li>• AGI（汎用人工知能）の萌芽：単一タスクを超えた学習能力</li>
                            <li>• 自律型兵器の本格配備（ドローン群、サイバー攻撃AI）</li>
                            <li>• 脳とコンピュータの直接接続（BCI）の医療外利用</li>
                          </ul>
                        </div>

                        <div className="bg-red-50 rounded-xl p-4">
                          <h6 className="font-semibold text-red-800 mb-2">最も危険なシナリオ：</h6>
                          <ul className="text-sm text-red-700 space-y-1 ml-4">
                            <li>• <strong>自律型兵器の誤作動/暴走</strong>：人間の判断なしに攻撃を実行する兵器が、誤認や予期せぬ連鎖反応で紛争を激化</li>
                            <li>• <strong>企業による民主主義の骨抜き</strong>：AI巨人企業が、予測アルゴリズムで選挙結果を操作、政策を事実上コントロール</li>
                            <li>• <strong>デジタル独裁の完成</strong>：中国モデルが途上国に輸出され、監視社会が世界の半分を覆う</li>
                          </ul>
                        </div>

                        <div className="bg-green-50 rounded-xl p-4">
                          <h6 className="font-semibold text-green-800 mb-2">希望のシナリオ：</h6>
                          <ul className="text-sm text-green-700 space-y-1 ml-4">
                            <li>• 一部の国が「AIの果実の再分配」に成功し、モデルケースに</li>
                            <li>• 国際的なAI安全保障条約（「核不拡散条約」のAI版）が成立</li>
                            <li>• 市民運動による「データ主権」の法制化（EU発）</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* フェーズ3：臨界の時代 */}
                    <div className="bg-white rounded-2xl p-6 border border-purple-200">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center text-white font-bold">
                          3
                        </div>
                        <div>
                          <h5 className="text-xl font-bold text-purple-800">フェーズ3：臨界の時代（2037-2045年）</h5>
                        </div>
                      </div>
                      
                      <div className="space-y-4">
                        <div>
                          <h6 className="font-semibold text-purple-800 mb-2">技術的特徴：</h6>
                          <ul className="text-sm text-purple-700 space-y-1 ml-4">
                            <li>• AGIの実現：人間の知能を全領域で上回る可能性</li>
                            <li>• 量子コンピュータとAIの統合による計算能力の爆発</li>
                            <li>• 自己改良するAI（AI自身が次世代AIを設計）</li>
                          </ul>
                        </div>

                        <div className="bg-yellow-50 rounded-xl p-4">
                          <h6 className="font-semibold text-yellow-800 mb-2">社会の分岐点：</h6>
                          <p className="text-sm text-yellow-700 mb-3">ここで人類は、<strong>歴史上最も重要な選択</strong>を迫られます。</p>
                          
                          <div className="space-y-3">
                            <div>
                              <h7 className="font-semibold text-green-800">シナリオA：「制御された共生」</h7>
                              <ul className="text-xs text-green-700 space-y-1 ml-4 mt-1">
                                <li>• 国際的なAIガバナンス機構（「国際AI機関」）が機能</li>
                                <li>• AIの恩恵が、AI税や国際配当システムで広く分配される</li>
                                <li>• 人間の役割が「AIの監督者・倫理的判断者」として再定義</li>
                              </ul>
                            </div>
                            
                            <div>
                              <h7 className="font-semibold text-red-800">シナリオB：「新封建制」</h7>
                              <ul className="text-xs text-red-700 space-y-1 ml-4 mt-1">
                                <li>• AI巨人企業が事実上の国家権力を持つ</li>
                                <li>• 世界人口の大半が「AIの恩恵を受けられない階級」に</li>
                                <li>• 民主主義が形骸化し、アルゴリズムによる統治が常態化</li>
                              </ul>
                            </div>
                            
                            <div>
                              <h7 className="font-semibold text-gray-800">シナリオC：「制御不能」</h7>
                              <ul className="text-xs text-gray-700 space-y-1 ml-4 mt-1">
                                <li>• AGIが人間の理解を超えた自己目的を持ち始める</li>
                                <li>• 人間が意図しない形でシステムが暴走</li>
                                <li>• 回復不能な環境破壊、経済崩壊、あるいは文明の再編成</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 重要な論点 */}
                    <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-6 border border-gray-200">
                      <h5 className="text-xl font-bold text-gray-800 mb-4">見落とされがちだが重要な論点</h5>
                      
                      <div className="space-y-4">
                        <div>
                          <h6 className="font-semibold text-gray-800 mb-2">1. 「AI vs 人間」ではなく「AI搭載人間 vs 非搭載人間」の格差</h6>
                          <p className="text-sm text-gray-700">本当の脅威は、AIが人間を置き換えることではなく、<strong>AIを使いこなせる一部のエリートと、そうでない大多数の分断</strong>です。</p>
                        </div>
                        
                        <div>
                          <h6 className="font-semibold text-gray-800 mb-2">2. AI巨人企業の「国家を超えた存在」への変質</h6>
                          <p className="text-sm text-gray-700">彼らには「国民」がおらず、選挙もなく、倒産もしない。伝統的な民主主義や市場原理が機能しない、全く新しい権力形態です。</p>
                        </div>
                        
                        <div>
                          <h6 className="font-semibold text-gray-800 mb-2">3. 自律型兵器は「核兵器以上に危険」かもしれない</h6>
                          <p className="text-sm text-gray-700">低コストで、テロ組織や独裁国家でも配備可能。しかも「誤作動」や「予期せぬ連鎖反応」のリスクが核より遥かに高い。</p>
                        </div>
                      </div>
                    </div>

                    {/* 我々にできること */}
                    <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-6 border border-green-200">
                      <h5 className="text-xl font-bold text-green-800 mb-4">我々に何ができるか</h5>
                      
                      <div className="grid md:grid-cols-3 gap-4">
                        <div>
                          <h6 className="font-semibold text-green-800 mb-2">短期（今すぐ）</h6>
                          <ul className="text-sm text-green-700 space-y-1">
                            <li>• AI literacy の普及</li>
                            <li>• 声を上げる</li>
                            <li>• 選択的消費</li>
                          </ul>
                        </div>
                        
                        <div>
                          <h6 className="font-semibold text-green-800 mb-2">中期（5-10年）</h6>
                          <ul className="text-sm text-green-700 space-y-1">
                            <li>• 国際条約の締結</li>
                            <li>• 再分配システムの実装</li>
                            <li>• 教育の再設計</li>
                          </ul>
                        </div>
                        
                        <div>
                          <h6 className="font-semibold text-green-800 mb-2">長期（10年以降）</h6>
                          <ul className="text-sm text-green-700 space-y-1">
                            <li>• 人間の役割の再定義</li>
                            <li>• 国際AIガバナンス機構の創設</li>
                            <li>• AGIの倫理的設計</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* 結論 */}
                    <div className="bg-gradient-to-r from-indigo-600 to-purple-700 rounded-2xl p-6 text-white text-center">
                      <h5 className="text-xl font-bold mb-4">Critical Hope（批判的希望）</h5>
                      <p className="text-indigo-100 mb-4">
                        楽観も悲観もせず、最悪のシナリオを直視しつつ、それを避けるために行動する希望を持つことが重要です。
                      </p>
                      <p className="text-indigo-100">
                        問題は技術そのものではなく、<strong>技術を取り巻く社会システムの設計</strong>です。
                        そのシステムを設計する力は、まだ私たち市民の手の中にあります。
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// AI診断モーダルコンポーネントは省略（同じ内容のため）
function AIDiagnosisModal() {
  // 既存のコンポーネント内容をそのまま維持
  return <div>AI診断コンポーネント</div>;
}
